import { useEffect, useMemo, useRef, useState } from 'react';

import { Empty2 } from '@/components/icon';
import { AiVideoReq, ResourceHistory, UrlInfo } from '@/interface/aigc';

import styles from './index.module.less';
import VideoHistoryItem from './item';

export interface IAigcVideoHistoryProps {
  histories: ResourceHistory[];
  isHorizontal: boolean;
  pagination: {
    page: number;
    size: number;
    total: number;
  };
  loading: boolean;
  generateVideo: (postData: AiVideoReq) => void;
  getSrc: (src: UrlInfo) => void;
  onDelete: (id: string) => void;
}

const AigcVideoHistory: React.FC<IAigcVideoHistoryProps> = (props) => {
  const { histories = [], isHorizontal, pagination, loading, generateVideo, getSrc, onDelete } = props;
  const [selectedVideo, setSelectedVideo] = useState<string>('initUrl');
  const latestItemRef = useRef<HTMLDivElement>(null);
  const historyLen = useRef<number>(histories.length);

  useEffect(() => {
    if (historyLen.current > 1 && histories.length > historyLen.current) {
      latestItemRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    historyLen.current = histories.length;
  }, [histories.length]);

  useEffect(() => {
    latestItemRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [pagination.page]);

  const handleSelect = (url: UrlInfo) => {
    if (!url.url) return;
    if (url.url === selectedVideo) {
      setSelectedVideo('');
      getSrc({ url: '', name: '' });
      return;
    }
    setSelectedVideo(url.url);
    getSrc(url);
  };

  const contentDom = useMemo(() => {
    if (loading) return null;
    return histories.length === 0
      ? (
        <div className={styles.placeholder}>
          <Empty2 />
          <div>暂未生成素材</div>
        </div>
      ) : (
        <div className={styles.history}>
          {histories.map((e, index) => (
            <div key={e.relateId || index} ref={index === 0 ? latestItemRef : null}>
              <VideoHistoryItem
                key={e.relateId || index}
                history={e}
                selectedVideo={selectedVideo}
                isHorizontal={isHorizontal}
                generateVideo={generateVideo}
                handleSelect={handleSelect}
                onDelete={onDelete}
              />
            </div>
          ))}
        </div>
      );
  }, [loading, histories, selectedVideo, isHorizontal, generateVideo, getSrc, onDelete]);

  return (
    <div className={styles.container}>
      {contentDom}
    </div>
  );
};

export default AigcVideoHistory;
